import Footer from "./Footer";
import Header from "./Header";
import { usePathname } from "next/navigation";
import USHeader from "./us-website/USHeader/USHeader";
import USFooter from "./us-website/USFooter/USFooter";
import { Toaster, FORM_TOAST_CONTAINER_ID } from "./Common/Toast";

export default function Layout({ children }) {
  const pathname = usePathname();
  const noHeaderFooterRules = [
    // Exact path matches
    "/blog-header",
    "/blog-footer",
    // Regex patterns
    /^\/product\/[a-zA-Z0-9-]+-\d+\/(tds|msds)$/,
    "/chemical-sourcing",
    "/source-uv-filters",
  ];

  const shouldHideHeaderFooter = noHeaderFooterRules.some((rule) =>
    typeof rule === "string" ? rule === pathname : rule.test(pathname)
  );

  return (
    <>
      {/*
        ONE toast container for the whole app, for the shared form feedback id.
        Mounted here because Layout renders exactly once: the forms that fire these
        toasts appear in modals and in multiple instances per page (USHeader mounts
        a contact modal, pages mount their own), so a container inside any of them
        was duplicated — and duplicate containers sharing an id render every toast
        once per container. `<Footer />`, which used to provide the only global
        container, is commented out below, so without this most pages had none at
        all and every toast failed silently.
      */}
      <Toaster containerId={FORM_TOAST_CONTAINER_ID} enableMultiContainer />
      {shouldHideHeaderFooter ? (
        <>{children}</>
      ) : (
        <>
          {" "}
          {/* <Header /> */}
          <USHeader />
          {children}
          {/* <Footer /> */}
          <USFooter />
        </>
      )}
    </>
  );
}
